import { useTranslations } from 'next-intl';
import type { JSX } from 'react';

import { ProductSelectData } from '@/app/hooks';
import getLocaleFormatting from '@/utils/getLocaleFormatting';

export interface PaginationProps extends Partial<
  Pick<ProductSelectData, 'endNumber' | 'startNumber'>
> {
  readonly totalCount?: number;
}

const Pagination = ({
  endNumber,
  startNumber,
  totalCount,
}: PaginationProps): JSX.Element | null => {
  const t = useTranslations();

  if (!endNumber || !startNumber || !totalCount) {
    return null;
  }

  return (
    <aside data-testid="product-select-pagination">
      {t.rich('pagination_label_start_end_total', {
        ...getLocaleFormatting,
        startNumber,
        endNumber,
        totalCount,
      })}
    </aside>
  );
};

export default Pagination;
